import useSubscribe from '@/hooks/useSubscribe';

export default function Newsletter() {
  const { status, formError, submit } = useSubscribe('tee-time-scoop', 'contact_alt');

  return (
    <section id="newsletter" className="bg-primary-800 px-4 md:px-8 py-16 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center max-w-6xl mx-auto">
        <div>
          <p className="font-label uppercase tracking-[0.28em] text-xs text-accent-400 font-semibold">Newsletter</p>
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-background-50 leading-[1.05] mt-3">Don&apos;t Miss the Next Tee Time Scoop!</h2>
          <p className="mt-4 text-background-200 text-base md:text-lg max-w-lg">
            Get our weekly digest of golf news, course reviews, and exclusive booking secrets delivered straight to your inbox. Join Golfers in the Know and subscribe to GreenSide News.
          </p>
        </div>

        <form id="tee-time-scoop-form" onSubmit={submit} className="bg-background-50 rounded-lg p-5 md:p-7 border-t-4 border-accent-500">
          <input type="text" name="contact_alt" className="gs-field-x" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          <label htmlFor="scoop-email" className="font-label uppercase tracking-widest text-xs font-semibold text-foreground-600">Email address</label>
          <div className="mt-2 flex flex-col sm:flex-row gap-3">
            <input
              id="scoop-email"
              type="email"
              name="email"
              required
              placeholder="you@example.com"
              className="flex-1 text-sm border border-background-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
            <button
              type="submit"
              disabled={status === 'sending'}
              className="bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider px-6 py-3 rounded-md whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'sending' ? 'Sending...' : 'Subscribe'}
            </button>
          </div>
          {status === 'success' && <p className="mt-3 text-sm text-primary-600 font-medium">You&apos;re in. Watch your inbox for the next scoop.</p>}
          {status === 'error' && <p className="mt-3 text-sm text-secondary-700 font-medium">{formError}</p>}
        </form>
      </div>
    </section>
  );
}